import React, { lazy } from 'react';
import { useInView } from '../hooks/useInView';
import { ThumbsUp, MessageCircle, Share2 } from 'lucide-react';
const testimonials = [{
  name: 'Carolina Mendoza',
  photo: 'https://images.unsplash.com/photo-1611432579699-484f7990b127?w=100&h=100&fit=crop&crop=face',
  time: '2 días',
  text: 'Pensé que era otra guía más de autoayuda, pero desde el día 3 empecé a notar la diferencia. Ahora cuando aparece esa voz, ya sé qué hacer. No desaparece, pero ya no me controla. 🙌',
  detail: 'Mamá de 2 · Lima',
  likes: 24,
  comments: 5
}, {
  name: 'Lucía Ríos Paredes',
  photo: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face',
  time: '5 días',
  text: 'Lo que más me sirvió fue el filtro de prioridades. Antes terminaba el día sintiéndome culpable por todo lo que no hice. Ahora cierro el día sabiendo que hice lo suficiente. ❤️ Se lo recomiendo a toda mamá que se exige demasiado.',
  detail: 'Mamá de 3 · Arequipa',
  likes: 41,
  comments: 12
}, {
  name: 'Andrea Pérez Castillo',
  photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
  time: '1 semana',
  text: 'Por primera vez sentí que alguien entendía lo que vivo. No es motivación vacía, es un método real. Los 10 minutos al día son totalmente manejables, incluso con el caos de la casa. 💛 Gracias de verdad.',
  detail: 'Mamá primeriza · Trujillo',
  likes: 33,
  comments: 8
}];
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section ref={ref} className="w-full bg-[#F5F1E8] py-10 px-6 md:py-14" data-id="element-224">
      <div className={`max-w-4xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-225">
        <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-8 text-center" data-id="element-226">
          Lo que dicen quienes ya la usaron
        </h2>

        <div className="grid md:grid-cols-3 gap-5" data-id="element-227">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col" data-id="element-228">
              {/* Facebook-style header */}
              <div className="flex items-center gap-3 px-4 pt-4 pb-2" data-id="element-229">
                <img src={t.photo} alt={t.name} className="w-10 h-10 rounded-full object-cover border-2 border-blue-500" loading="lazy" data-id="element-230" />
                <div className="flex-1 min-w-0" data-id="element-231">
                  <p className="font-sans font-semibold text-sm text-[#1c1e21] leading-tight truncate" data-id="element-232">
                    {t.name}
                  </p>
                  <p className="font-sans text-xs text-[#65676b]" data-id="element-233">
                    {t.time} · <span className="inline-block" data-id="element-234">🌐</span>
                  </p>
                </div>
              </div>

              {/* Post text */}
              <div className="px-4 pb-3 flex-1" data-id="element-235">
                <p className="font-sans text-[#1c1e21] text-sm leading-relaxed" data-id="element-236">
                  {t.text}
                </p>
                <p className="font-sans text-xs text-[#65676b] mt-1" data-id="element-237">
                  {t.detail}
                </p>
              </div>

              {/* Reactions bar */}
              <div className="px-4 py-1.5 flex items-center justify-between border-t border-gray-100" data-id="element-238">
                <div className="flex items-center gap-1" data-id="element-239">
                  <span className="flex -space-x-1" data-id="element-240">
                    <span className="w-[18px] h-[18px] rounded-full bg-blue-500 flex items-center justify-center text-white text-[10px]" data-id="element-241">
                      👍
                    </span>
                    <span className="w-[18px] h-[18px] rounded-full bg-red-500 flex items-center justify-center text-white text-[10px]" data-id="element-242">
                      ❤️
                    </span>
                  </span>
                  <span className="font-sans text-xs text-[#65676b] ml-1" data-id="element-243">
                    {t.likes}
                  </span>
                </div>
                <span className="font-sans text-xs text-[#65676b]" data-id="element-244">
                  {t.comments} comentarios
                </span>
              </div>

              {/* Action buttons */}
              <div className="px-2 py-1 border-t border-gray-200 flex items-center justify-around" data-id="element-245">
                <button className="flex items-center gap-1.5 py-1.5 px-3 rounded-md hover:bg-gray-100 transition-colors" data-id="element-246">
                  <ThumbsUp className="w-4 h-4 text-[#65676b]" data-id="element-247" />
                  <span className="font-sans text-xs font-semibold text-[#65676b]" data-id="element-248">
                    Me gusta
                  </span>
                </button>
                <button className="flex items-center gap-1.5 py-1.5 px-3 rounded-md hover:bg-gray-100 transition-colors" data-id="element-249">
                  <MessageCircle className="w-4 h-4 text-[#65676b]" data-id="element-250" />
                  <span className="font-sans text-xs font-semibold text-[#65676b]" data-id="element-251">
                    Comentar
                  </span>
                </button>
                <button className="flex items-center gap-1.5 py-1.5 px-3 rounded-md hover:bg-gray-100 transition-colors" data-id="element-252">
                  <Share2 className="w-4 h-4 text-[#65676b]" data-id="element-253" />
                  <span className="font-sans text-xs font-semibold text-[#65676b]" data-id="element-254">
                    Compartir
                  </span>
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}